import { h, Component } from 'preact';

import scrollToElement from 'scroll-to-element';
import parseAddress from 'parse-address';

import FontAwesomeIcon from './fontAwesomeIcon.js';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

import style from '../../style/form.sass';
import ContentHandler from '../util/contentHandler.js';

const googleAddressComponentTypeFunctions = {
  'room': function(formData, component){
    formData.set('location[unit]', component.long_name);
  },
  'street_address': function(formData, component){
    formData.set('location[street]', component.long_name);
  },
  'street_number': function(formData, component){
    let streetName = formData.has('location[street]')?formData.get('location[street]'):'';
    formData.set('location[street]', component.long_name+' '+streetName);
  },
  'route': function(formData, component){
    let streetNumber = formData.has('location[street]')?formData.get('location[street]'):'';
    formData.set('location[street]', streetNumber+''+component.long_name);
  },
  'locality': function(formData, component){
    formData.set('location[city]', component.long_name);
  },
  'administrative_area_level_1': function(formData, component){
    formData.set('location[state]', component.long_name);
  },
  'country': function(formData, component){
    formData.set('location[country]', component.long_name);
  },
  'postal_code': function(formData, component){
    formData.set('location[zip]', component.long_name);
  },
};

export const getFormStyleClassNames = (brand) => {
  if(brand === 'rheem'){
    return {
      formStyle: style.form,
      formOuterContainerStyle: style.formOuterContainer,
      formInnerContainerStyle: style.formInnerContainer,
      formContentContainerStyle: style.formContentContainer,
      formHeaderStyle: style.formHeader,
      formHeaderSubTitleStyle: style.formHeaderSubTitle,
      formHeaderContractorStyle: style.formHeaderContractor,
      submitButtonStyle: style.submitButton
    };
  }
  if(brand === 'ruud'){
    return {
      formStyle: style.formRuud,
      formOuterContainerStyle: style.formOuterContainerRuud,
      formInnerContainerStyle: style.formInnerContainerRuud,
      formContentContainerStyle: style.formContentContainerRuud,
      formHeaderStyle: style.formHeaderRuud,
      formHeaderSubTitleStyle: style.formHeaderSubTitleRuud,
      formHeaderContractorStyle: style.formHeaderContractorRuud,
      submitButtonStyle: style.submitButtonRuud
    };
  }
  if(brand === 'friedrich'){
    return {
      formStyle: style.formFriedrich,
      formOuterContainerStyle: style.formOuterContainerFriedrich,
      formInnerContainerStyle: style.formInnerContainerFriedrich,
      formContentContainerStyle: style.formContentContainerFriedrich,
      formHeaderStyle: style.formHeaderFriedrich,
      formHeaderSubTitleStyle: style.formHeaderSubTitleFriedrich,
      formHeaderContractorStyle: style.formHeaderContractorFriedrich,
      submitButtonStyle: style.submitButtonFriedrich
    };
  }
  return {
    formStyle: style.form,
    formOuterContainerStyle: style.formOuterContainer,
    formInnerContainerStyle: style.formInnerContainer,
    formContentContainerStyle: style.formContentContainer,
    formHeaderStyle: style.formHeader,
    formHeaderSubTitleStyle: style.formHeaderSubTitle,
    formHeaderContractorStyle: style.formHeaderContractor,
    submitButtonStyle: style.submitButton
  };
}

export default class Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formSendPending: false,
      firstName: null,
      lastName: null,
      phoneNumber: null,
      isMobileMumber: 'true',
      email: null,
      location: null,
      description: '',
      doSendEmailNotifications: false,
      doSendMobileNotifications: false
    };

    this.locationInput = null;
    this.locationAutocomplete = null;
    this.onPlaceChanged = this.onPlaceChanged.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.cancelSubmit = this.cancelSubmit.bind(this);
  }
  componentDidMount(){
    this.bindLocationInput();
    if(this.props.doShowModal){
      scrollToElement(this.base,{
        align: 'top'
      });
    }
  }
  componentDidUpdate(prevProps, prevState, snapshot){
    this.bindLocationInput();
    if(this.props.doShowModal && this.props.doShowModal != prevProps.doShowModal){
      scrollToElement(this.base,{
        align: 'top'
      });
    }
  }
  bindLocationInput(){
    if(this.props.googleMapsApiKeyIsValid && !this.locationAutocomplete){
      this.locationAutocomplete = new window.google.maps.places.Autocomplete(
        this.locationInput, {
          types: ['geocode'],
        }
      );
      this.locationAutocomplete.addListener('place_changed', this.onPlaceChanged);
    }else{
      this.locationInput.onChange = this.handleInputChange;
    }
  }
  onPlaceChanged(){
    const location = this.locationAutocomplete.getPlace();
    if(location){
      this.setState({location: location});
    }
  }
  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    let stateUpdate = {
      [name]: value
    };
    if(target.name === 'isMobileMumber' && value === 'false'){
      stateUpdate.doSendMobileNotifications = false;
    }
    this.setState(stateUpdate);
  }
  handleSubmit(event){
    event.preventDefault();
    const formData = new FormData();
    this.addStateInfoToFormData(formData).then((formData)=>{
      return this.addExtraInfoToFormData(formData);
    }).then((formData)=>{
      this.setState({formSendPending: true}, ()=>{
        this.props.sendFormData(formData);
      });
    });
  }
  addStateInfoToFormData(formData){
    formData.set('firstName', this.state.firstName);
    formData.set('lastName', this.state.lastName);
    formData.set('phoneNumber', this.state.phoneNumber);
    formData.set('isMobileMumber', this.state.isMobileMumber);
    formData.set('email', this.state.email);
    formData.set('doSendMobileNotifications', this.state.doSendMobileNotifications);
    formData.set('doSendEmailNotifications', this.state.doSendEmailNotifications);
    formData.set('description', this.state.description);
    return this.addAddressToFormData(formData);
  }
  addExtraInfoToFormData(formData){
    return new Promise((resolve)=>{
      const contentHandler = new ContentHandler();
      let forwardingPhoneNumber = contentHandler.getTrackingPhoneNumber(this.props);
      formData.set('source', 'dispatch_me');
      formData.set('sourceUrl', window.location.href);
      formData.set('vsref', contentHandler.sanitizePhoneNumber(forwardingPhoneNumber));
      formData.set('contractorId', this.props.modalData.contractor.externalData.ContractorID);
      formData.set('contractorEmail', this.props.modalData.contractor.externalData.CorporateEmail);
      formData.set('contractorName', this.props.modalData.contractor.externalData.CompanyName);
      formData.set('serviceType', 'hvac');
      resolve(formData);
    });
  }
  addAddressToFormData(formData){
    return new Promise((resolve)=>{
      if(!this.state.location){
        const addressObj = parseAddress.parseLocation(this.locationInput.value);
        formData.set('location[street]', addressObj.number+' '+addressObj.prefix+' '+addressObj.street+' '+addressObj.type+' '+addressObj.suffix);
        formData.set('location[city]', addressObj.city);
        formData.set('location[state]', addressObj.state);
        formData.set('location[country]', 'US');
        formData.set('location[zip]', addressObj.zip);
        resolve(formData);
      }else{
        this.state.location.address_components.forEach((element)=>{
          element.types.forEach((type)=>{
            if(typeof googleAddressComponentTypeFunctions[type] === 'function'){
              googleAddressComponentTypeFunctions[type](formData, element);
            }
          });
        });
        if(!Array.from(formData.keys()).some((key)=>{ return (key.indexOf('location') > -1);})){
          formData.append('location[]', 'N/A');
        }
        resolve(formData);
      }
    });
  }
  cancelSubmit(event){
    event.preventDefault();
    this.props.hideModal();
  }
  render(props, state){
    const spinner = this.state.formSendPending?<FontAwesomeIcon icon={faSpinner} pulse />:null;
    let phoneNotifcationComponent = null;
    if(this.state.isMobileMumber==='true'){
      phoneNotifcationComponent = (
        <label>
          <input
            type="checkbox"
            name="doSendMobileNotifications"
            onChange={this.handleInputChange}
            checked={this.state.doSendMobileNotifications}
          />
          PHONE
        </label>
      );
    }
    const classNames = getFormStyleClassNames(props.brand);

    return (
      <form className={classNames.formStyle}  onSubmit={this.handleSubmit}>
        <div className={classNames.formOuterContainerStyle}>
          <div className={classNames.formInnerContainerStyle}>
            <div className={classNames.formContentContainerStyle}>
              <h2 className={classNames.formHeaderStyle}>
                <span className={classNames.formHeaderSubTitleStyle}>SEND MESSAGE TO</span>
                &nbsp;
                <span className={classNames.formHeaderContractorStyle}>{props.modalData.contractor.name.toUpperCase()}</span>
              </h2>
              <input className={[style.input, style.firstNameInput].join(' ')}
                name="firstName"
                type="text"
                placeholder="FIRST NAME"
                required
                onChange={this.handleInputChange}
                value={this.state.firstName}
              />
              <input className={[style.input, style.lastNameInput].join(' ')}
                name="lastName"
                type="text"
                placeholder="LAST NAME"
                required
                onChange={this.handleInputChange}
                value={this.state.lastName}
              />
              <input className={style.input}
                name="phoneNumber"
                type="tel"
                placeholder="PHONE NUMBER"
                required
                onChange={this.handleInputChange}
                value={this.state.phoneNumber}
              />
              <div className={style.radioContainer}>
                <span>IS THIS A MOBILE PHONE NUMBER?</span>
                <label>
                  <input
                    type="radio"
                    name="isMobileMumber"
                    value='true'
                    onChange={this.handleInputChange}
                    checked={this.state.isMobileMumber==='true'}
                  />
                  YES
                </label>
                <label>
                  <input
                    type="radio"
                    name="isMobileMumber"
                    value='false'
                    onChange={this.handleInputChange}
                    checked={this.state.isMobileMumber==='false'}
                  />
                  NO
                </label>
              </div>
              <input className={style.input}
                name="email"
                type="email"
                placeholder="EMAIL"
                required
                onChange={this.handleInputChange}
                value={this.state.email}
              />
              <input className={style.locationInput}
                type="text"
                placeholder="ADDRESS"
                ref={(input) => { this.locationInput = input; }}
              />
              <textarea
                className={style.textarea}
                name="description"
                placeholder="SERVICE NEEDED"
                onChange={this.handleInputChange}
                value={this.state.description}
              />
              <div className={style.checkboxContainer}>
                <span>SEND NOTIFICATIONS BY:</span>
                <label>
                  <input
                    type="checkbox"
                    name="doSendEmailNotifications"
                    onChange={this.handleInputChange}
                    checked={this.state.doSendEmailNotifications}
                  />
                  EMAIL
                </label>
                {phoneNotifcationComponent}
              </div>
              <div>
                <button className={classNames.submitButtonStyle} disabled={this.state.formSendPending} type="submit">
                  SUBMIT
                  {spinner}
                </button>
                <a className={style.cancelLink} onClick={this.cancelSubmit} tabIndex="0">CLOSE</a>
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }
}